import type { ReactElement } from 'react'
import { Link } from 'react-router-dom'

export function NotFoundView(): ReactElement {
  return (
    <div className="flex min-h-0 flex-1 flex-col items-center justify-center gap-3 px-4 text-center">
      <p className="text-4xl font-bold text-white/80">404</p>
      <p className="text-sm text-white/60">找不到这个页面，它可能已经被移除了。</p>
      <Link
        to="/"
        className="rounded-lg border border-accent/60 px-4 py-2 text-sm text-accent no-underline hover:bg-accent/10"
      >
        返回大厅
      </Link>
    </div>
  )
}
